export const API_PATH_apiUserInvitationsTemplateDefaultGet = '/services/users-invitations/template-default';
